<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            :isToyear="true"
            label="(기간)조치완료 요청일"
            name="actionCompleteRequestDates"
            v-model="searchParam.actionCompleteRequestDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :disabled="taskTypeDisabled"
            codeGroupCd="IBM_TASK_TYPE_CD"
            :rejectItems="['ITT0000145']"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmTaskTypeCd"
            label="업무"
            v-model="searchParam.ibmTaskTypeCd"
          ></c-select>
        </div>
        <div v-if="stepVisible" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            stepperGrpCd="IBM_STEP_CD"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ibmStepCd"
            label="진행단계"
            v-model="searchParam.ibmStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 요청부서 -->
          <c-dept 
            :isFirstValue="false"
            type="search" 
            label="요청부서" 
            name="improveRequestDeptCd" 
            v-model="searchParam.improveRequestDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 조치부서 -->
          <c-dept 
            type="search" 
            label="조치부서" 
            name="actionDeptCd" 
            :isFirstValue="isFirstValueDept"
            v-model="searchParam.actionDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="IBM_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmClassCd"
            label="개선구분"
            v-model="searchParam.ibmClassCd"
          ></c-select>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="지연된 업무 확인"
            name="overFlag"
            v-model="searchParam.overFlag"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="임시대책 개선 확인"
            name="tempTaskFlag"
            v-model="searchParam.tempTaskFlag"
          />
        </div> -->
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="개선 목록"
      tableId="impr01"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn 
            :disabled="!grid.data || grid.data.length === 0"
            label="개선결과보고서" 
            icon="print"
            @btnClicked="imprResultPrint" />
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="addEtcImpr" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='actionCompleteRequestDate'">
          <span :style="props.row.approvalStatusCd === 'ASC9999999' ? 'text-decoration: line-through' : ''">
            {{props.row.actionCompleteRequestDate}}
            <q-badge v-if="props.row.completeDateOver > 0
              && props.row.ibmStepCd !== 'IS00000001' && props.row.approvalStatusCd !== 'ASC9999999'" color="negative" label="지연" class="blinking" />
          </span>
          <span v-if="props.row.approvalStatusCd === 'ASC9999999'">
            👉 {{props.row.targetDate}}
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'impr',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          mainPeriod: [],
          mainPlantCd: null,
          plantCd: null,
          ibmTaskTypeCd: null,
          actionCompleteRequestDates: [],
          patrolGubun: '',
          year: '',
          itemGubun: '',
          stepGubun: '',
          sop4mClassCd: '',
          isMain: false,
        }
      },
    },
  },
  data() {
    return {
      isFirstValueDept: true,
      searchParam: {
        plantCd: null,
        actionCompleteRequestDates: [],
        // ibmClassCd: 'IC00000001',
        ibmClassCd: 'IC00000005',
        ibmTaskTypeCd: 'ITT0000065',
        ibmStepCd: null,
        improveRequestDeptCd: '',
        actionDeptCd: '',
        actionFlag: 'D',
        overFlag: 'N',
        tempTaskFlag: 'N',
        sop4mClassCd: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'groupId' },
          { index: 1, colName: 'groupId' },
          { index: 2, colName: 'groupId' },
          { index: 3, colName: 'groupId' },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:90px',
            sortable: true,
          },
          {
            name: 'ibmTaskTypeName',
            field: 'ibmTaskTypeName',
            label: '업무',
            align: 'center',
            style: 'width:90px',
            sortable: true
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'actionContents',
            field: 'actionContents',
            label: '조치',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'improveRequestDeptName',
            field: 'improveRequestDeptName',
            label: '요청부서',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'sopImprovementId',
            field: 'sopImprovementId',
            label: '개선번호',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'improveRequestContents',
            field: 'improveRequestContents',
            label: '요청정보',
            align: 'left',
            style: 'width:200px',
            type: 'link',
            sortable: true,
          },
          // {
          //   name: 'sopCountermeasureName',
          //   field: 'sopCountermeasureName',
          //   label: '대책',
          //   align: 'center',
          //   style: 'width:100px',
          //   sortable: true
          // },
          {
            name: 'ibmStepName',
            field: 'ibmStepName',
            label: '진행단계',
            align: 'center',
            style: 'width:100px',
            sortable: true
          },
          {
            name: 'actionCompleteRequestDate',
            field: 'actionCompleteRequestDate',
            label: '조치완료<br> 요청일',
            align: 'center',
            style: 'width:100px',
            type: 'custom',
            sortable: true,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            label: '조치부서',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'actionUserNames',
            field: 'actionUserNames',
            label: '조치자',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'actionCompleteDate',
            field: 'actionCompleteDate',
            label: '조치완료일',
            align: 'center',
            style: 'width:90px',
            sortable: true,
          },
          {
            label: '사진여부',
            align: 'center',
            sortable: false,
            child: [
              {
                name: 'beforeAttach',
                field: 'beforeAttach',
                label: '개선 전',
                align: 'center',
                style: 'width:60px',
                sortable: false,
              },
              {
                name: 'afterAttach',
                field: 'afterAttach',
                label: '개선 후',
                align: 'center',
                style: 'width:60px',
                sortable: false,
              },
            ]
          },
          // {
          //   name: 'approvalStatusName',
          //   field: 'approvalStatusName',
          //   label: '지연사유 결재',
          //   align: 'center',
          //   sortable: true,
          //   style: 'width:100px',
          // },
        ],
        data: [],
        height: '',
      },
      editable: true,
      listUrl: '',
      printUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    taskTypeDisabled() {
      return Boolean(this.popupParam.ibmTaskTypeCd)
    },
    stepVisible() {
      return !this.popupParam.isMain
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.ibm.improve.list.url
      this.printUrl = selectConfig.sop.ibm.improve.print.url
      // code setting
      if (this.popupParam.isMain) {
        this.grid.height = '500px'
        this.$set(this.searchParam, 'ibmClassCd', null)
        this.$set(this.searchParam, 'patrolGubun', this.popupParam.patrolGubun)
        this.$set(this.searchParam, 'year', this.popupParam.year)
        this.$set(this.searchParam, 'itemGubun', this.popupParam.itemGubun)
        this.$set(this.searchParam, 'stepGubun', this.popupParam.stepGubun)
        this.$set(this.searchParam, 'sop4mClassCd', this.popupParam.sop4mClassCd)
      }
      if (this.popupParam.mainPeriod) {
        // 메인에서 호출한 팝업파라미터
        if (this.popupParam.mainPeriod.length > 0) {
          this.searchParam.plantCd = (!this.popupParam.mainPlantCd || this.popupParam.mainPlantCd.length > 3 ? null : this.popupParam.mainPlantCd);
          this.searchParam.actionCompleteRequestDates = this.popupParam.mainPeriod;
          this.searchParam.actionDeptCd = '';
          this.isFirstValueDept = false;
        }
      }
      if (this.popupParam.ibmTaskTypeCd ) {
        this.searchParam.plantCd = (!this.popupParam.plantCd || this.popupParam.plantCd.length > 3 ? null : this.popupParam.plantCd);
        this.searchParam.ibmTaskTypeCd = this.popupParam.ibmTaskTypeCd;
        this.searchParam.actionCompleteRequestDates = this.popupParam.actionCompleteRequestDates;
        this.searchParam.actionDeptCd = '';
        this.isFirstValueDept = false;
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    addEtcImpr() {
      // 대기, 수질, 폐기물, 화학물질 개선 등록
      this.linkClick()
    },
    linkClick(row, col, index) {
      if (!row || row.ibmClassCd == 'IC00000001') {// 즉시조치
        this.popupOptions.title = '개선 상세'; // 개선 상세
        this.popupOptions.isFull = true;
        this.popupOptions.param = {
          sopImprovementId: row ? row.sopImprovementId : '',
          ibmTaskTypeCd: row ? row.ibmTaskTypeCd : 'ITT9999999',
        };
        this.popupOptions.target = () => import(`${'./imprDetail.vue'}`);
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.isFull = false;
        this.popupOptions.param = {
          sopImprovementId: row ? row.sopImprovementId : '',
          ibmTaskTypeCd: row ? row.ibmTaskTypeCd : 'ITT9999999',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '80%';
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    imprResultPrint() {
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(
        _result => {
          let fileOrgNm = '개선 결과 보고서_' + this.$comm.getToday() + '.xlsx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    }
  }
};
</script>
